import { t } from '@/core/localization';
import { documentFlowEnabled } from './documentFlowEnabled';
const documentFlowItems = documentFlowEnabled
    ? [
        {
            groupName: t('document.flow.sidebar.section'),
            menuItems: ['reclamations', 'edo'],
        },
    ]
    : [];
export const sidebarNavigationItems = [
    {
        groupName: t('general.sidebar.section'),
        menuItems: ['orders', 'customers', 'suppliers', 'priceLists', 'stockReceipt', 'stocks', 'shipping'],
    },
    ...documentFlowItems,
    {
        groupName: t('reports.sidebar.section'),
        menuItems: ['customerDebtReport', 'supplierDebtReport', 'paymentReports'],
    },
    {
        groupName: t('settings.sidebar.section'),
        menuItems: ['settings'],
    },
];
